import request from '@/utils/request'

// 页面相关API
export const pageApi = {



  // 使用查询参数获取单个页面
  getPageByParams(params) {
    return request({
      url: '/pages',
      method: 'get',
      params
    })
  },


}

// 产品相关API
export const productApi = {
  // 获取产品列表
  getProductList(params) {
    return request({
      url: '/products',
      method: 'get',
      params
    })
  },

  // 根据ID获取单个产品
  getProductById(id) {
    return request({
      url: `/products?id=${id}`,
      method: 'get'
    })
  },

  // 使用查询参数获取单个产品
  getProductByParams(params) {
    return request({
      url: '/products',
      method: 'get',
      params
    })
  },
//获取产品类别列表
 getProductCat(id) {
    return request({
      url: `/procat`,
      method: 'get'
    })
  },
}

// 系统设置相关API
export const systemApi = {
  // 获取系统设置信息
  getSystemSettings() {
    return request({
      url: '/system',
      method: 'get'
    })
  }
}